var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-3" }, [
        _c("div", { staticClass: "card mb-5" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v(
                "\n                        Projekt " +
                  _vm._s(_vm.project.id) +
                  "\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "question" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Kategorie")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.category))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "euro" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [_vm._v("Betrag")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm._f("currency")(_vm.project.sum)))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "check" } })],
                1
              ),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "user" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Zuständiger Mitarbeiter")
                  ]),
                  _vm._v(" "),
                  _vm.project.client.manager
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "text-dark text-hover-primary mb-1 font-size-lg",
                          attrs: { href: "#" }
                        },
                        [_vm._v(_vm._s(_vm.project.client.manager.pre_name))]
                      )
                    : _vm._e()
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex mb-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5"
                },
                [
                  _vm._v(
                    "\n                            Anfrage: " +
                      _vm._s(_vm.project.offer.anfrage) +
                      "\n                        "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-footer" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-xs btn-hubspot mr-1",
                attrs: {
                  target: "_blank",
                  href:
                    "https://app-eu1.hubspot.com/contacts/25794910/deal/" +
                    _vm.project.offer.hubspot_id +
                    "/"
                }
              },
              [_vm._v("Zum Hubspot\n                        Deal")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card mb-5" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v("\n                        Kontakt: "),
              _vm.project.client.user.pre_name
                ? _c("span", [
                    _vm._v(_vm._s(_vm.project.client.user.pre_name) + " ")
                  ])
                : _vm._e(),
              _vm._v(
                _vm._s(_vm.project.client.user.name) + "\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "mail" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [_vm._v("E-Mail")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.client.user.email))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "phone" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Telefon")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.client.phone))]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-footer" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-xs btn-hubspot mr-1",
                attrs: {
                  target: "_blank",
                  href:
                    "https://app-eu1.hubspot.com/contacts/25794910/contact/" +
                    _vm.project.client.user.hubspot_id +
                    "/"
                }
              },
              [_vm._v("Zum Hubspot\n                        Kontakt")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card mb-5" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h3", { staticClass: "card-title" }, [
              _vm._v(
                "\n                        Unternehmen: " +
                  _vm._s(_vm.project.client.company) +
                  "\n                    "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "mail" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [_vm._v("E-Mail")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.client.main_mail))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "phone" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Telefon")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.client.phone))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "intervall" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Projekt Intervall")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.client.intervall))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center mb-5" }, [
              _c(
                "div",
                { staticClass: "symbol symbol-40 symbol-light-primary mr-4" },
                [_c("Icon", { attrs: { type: "image" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column font-weight-bold" },
                [
                  _c("span", { staticClass: "text-muted" }, [
                    _vm._v("Bilder pro Intervall")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-dark text-hover-primary mb-1 font-size-lg",
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.project.client.estimation_range))]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-footer" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-xs btn-hubspot mr-1",
                attrs: {
                  target: "_blank",
                  href:
                    "https://app-eu1.hubspot.com/contacts/25794910/company/" +
                    _vm.project.client.hubspot_id +
                    "/"
                }
              },
              [_vm._v("Zum\n                        Hubspot Unternehmen")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-xs btn-primary mr-1",
                attrs: {
                  target: "_blank",
                  href: "/kunde-" + _vm.project.client.id + "/"
                }
              },
              [_vm._v("Zum Admin Unternehmen")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-9" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c(
              "div",
              { staticClass: "card card-custom card-stretch gutter-b mb-5" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body pt-8" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "symbol symbol-40 symbol-light-primary mr-3"
                        },
                        [_c("Icon", { attrs: { type: "image" } })],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column font-weight-bold justify-content-end"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addTask("image")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "svg-icon svg-icon-primary svg-icon-2x"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        width: "24px",
                                        height: "24px",
                                        viewBox: "0 0 24 24",
                                        version: "1.1"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              points: "0 0 24 0 24 24 0 24"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero",
                                              opacity: "1",
                                              transform:
                                                "translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "symbol symbol-40 symbol-light-primary mr-3"
                        },
                        [_c("Icon", { attrs: { type: "service" } })],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column font-weight-bold" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addTask("service")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "svg-icon svg-icon-primary svg-icon-2x"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        width: "24px",
                                        height: "24px",
                                        viewBox: "0 0 24 24",
                                        version: "1.1"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              points: "0 0 24 0 24 24 0 24"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero",
                                              opacity: "1",
                                              transform:
                                                "translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "symbol symbol-40 symbol-light-primary mr-3"
                        },
                        [
                          _c("Icon", { attrs: { type: "marketplace-package" } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column font-weight-bold" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addTask("package")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "svg-icon svg-icon-primary svg-icon-2x"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        width: "24px",
                                        height: "24px",
                                        viewBox: "0 0 24 24",
                                        version: "1.1"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              points: "0 0 24 0 24 24 0 24"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero",
                                              opacity: "1",
                                              transform:
                                                "translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "symbol symbol-40 symbol-light-primary mr-3"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "svg-icon svg-icon-primary svg-icon-2x"
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    width: "24px",
                                    height: "24px",
                                    viewBox: "0 0 24 24",
                                    version: "1.1"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        stroke: "none",
                                        "stroke-width": "1",
                                        fill: "none",
                                        "fill-rule": "evenodd"
                                      }
                                    },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          x: "0",
                                          y: "0",
                                          width: "24",
                                          height: "24"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M4,9.67471899 L10.880262,13.6470401 C10.9543486,13.689814 11.0320333,13.7207107 11.1111111,13.740321 L11.1111111,21.4444444 L4.49070127,17.526473 C4.18655139,17.3464765 4,17.0193034 4,16.6658832 L4,9.67471899 Z M20,9.56911707 L20,16.6658832 C20,17.0193034 19.8134486,17.3464765 19.5092987,17.526473 L12.8888889,21.4444444 L12.8888889,13.6728275 C12.9050191,13.6647696 12.9210067,13.6561758 12.9368301,13.6470401 L20,9.56911707 Z",
                                          fill: "#000000"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M4.21611835,7.74669402 C4.30015839,7.64056877 4.40623188,7.55087574 4.5299008,7.48500698 L11.5299008,3.75665466 C11.8237589,3.60013944 12.1762411,3.60013944 12.4700992,3.75665466 L19.4700992,7.48500698 C19.5654307,7.53578262 19.6503066,7.60071528 19.7226939,7.67641889 L12.0479413,12.1074394 C11.9974761,12.1365754 11.9509488,12.1699127 11.9085461,12.2067543 C11.8661433,12.1699127 11.819616,12.1365754 11.7691509,12.1074394 L4.21611835,7.74669402 Z",
                                          fill: "#000000",
                                          opacity: "0.3"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column font-weight-bold" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addTask("package_return")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "svg-icon svg-icon-primary svg-icon-2x"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        width: "24px",
                                        height: "24px",
                                        viewBox: "0 0 24 24",
                                        version: "1.1"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              points: "0 0 24 0 24 24 0 24"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero",
                                              opacity: "1",
                                              transform:
                                                "translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "symbol symbol-40 symbol-light-primary mr-3"
                        },
                        [_c("Icon", { attrs: { type: "minus" } })],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column font-weight-bold" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addTask("service_price")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "svg-icon svg-icon-primary svg-icon-2x"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        width: "24px",
                                        height: "24px",
                                        viewBox: "0 0 24 24",
                                        version: "1.1"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              points: "0 0 24 0 24 24 0 24"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero",
                                              opacity: "1",
                                              transform:
                                                "translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "symbol symbol-40 symbol-light-primary mr-3"
                        },
                        [_c("Icon", { attrs: { type: "euro" } })],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column font-weight-bold" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.addTask("other_costs")
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "svg-icon svg-icon-primary svg-icon-2x"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        width: "24px",
                                        height: "24px",
                                        viewBox: "0 0 24 24",
                                        version: "1.1"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            stroke: "none",
                                            "stroke-width": "1",
                                            fill: "none",
                                            "fill-rule": "evenodd"
                                          }
                                        },
                                        [
                                          _c("polygon", {
                                            attrs: {
                                              points: "0 0 24 0 24 24 0 24"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z",
                                              fill: "#FFFFFF",
                                              "fill-rule": "nonzero",
                                              opacity: "1",
                                              transform:
                                                "translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card card-custom card-stretch gutter-b mb-5" },
              [
                _vm._m(8),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body pt-8" },
                  [
                    _c("project-details", {
                      attrs: {
                        "service-providers": _vm.serviceProviders,
                        "prio-arr": _vm.prioArr,
                        "kw-planning": _vm.kwPlanning,
                        "photographer-arr": _vm.photographerArr,
                        "project-data": _vm.project
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            _vm._l(_vm.project.tasks, function(task) {
              return _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c("project-task", {
                    attrs: {
                      "project-task": task,
                      "estimation-range": _vm.estimationRange,
                      "mid-amount-arr": _vm.midAmountArr
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column font-weight-bold" }, [
      _c("span", { staticClass: "text-muted" }, [_vm._v("Status")]),
      _vm._v(" "),
      _c("button", { staticClass: "btn btn-success mb-1 font-size-lg" }, [
        _vm._v("TODO")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header border-0 pt-2" }, [
      _c("h3", { staticClass: "card-title align-items-start flex-column" }, [
        _vm._v(
          "\n                                Tasks hinzufügen\n                            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column pl-0 col-8 font-weight-bold" },
      [
        _c(
          "a",
          {
            staticClass: "text-dark text-hover-primary mb-1 font-size-lg",
            attrs: { href: "#" }
          },
          [_vm._v("Bilder")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("Task mit Preisen pro Bild, Stunde oder fix")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column pl-0 col-8 font-weight-bold" },
      [
        _c(
          "a",
          {
            staticClass: "text-dark text-hover-primary mb-1 font-size-lg",
            attrs: { href: "#" }
          },
          [_vm._v("Service")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("Task für Service wie Bildbearbeitung, Management usw.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column pl-0 col-8 font-weight-bold" },
      [
        _c(
          "a",
          {
            staticClass: "text-dark text-hover-primary mb-1 font-size-lg",
            attrs: { href: "#" }
          },
          [_vm._v("Paket")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("Task mit fixem Preis für Amazon oder andere Marktplätze")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column pl-0 col-8 font-weight-bold" },
      [
        _c(
          "a",
          {
            staticClass: "text-dark text-hover-primary mb-1 font-size-lg",
            attrs: { href: "#" }
          },
          [_vm._v("Rücksendung")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-muted" }, [
          _vm._v(
            "Die Rücksendung erscheint auch im Angebot so wie auf der Rechung des Kunden."
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column pl-0 col-8 font-weight-bold" },
      [
        _c(
          "a",
          {
            staticClass: "text-dark text-hover-primary mb-1 font-size-lg",
            attrs: { href: "#" }
          },
          [_vm._v("Dienstleister Bilder")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("Kosten für die Bearbeitung der Bilder vom Dienstleister")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex flex-column pl-0 col-8 font-weight-bold" },
      [
        _c(
          "a",
          {
            staticClass: "text-dark text-hover-primary mb-1 font-size-lg",
            attrs: { href: "#" }
          },
          [_vm._v("Andere Ausgaben")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "text-muted" }, [
          _vm._v(
            "Task mit Ausgaben, die dem Kunden in Rechnung gestellt werden können."
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header border-0 pt-2" }, [
      _c("h3", { staticClass: "card-title align-items-start flex-column" }, [
        _vm._v(
          "\n                                Projektdetails\n                            "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }